export default {
  avatarImage: {
    height: "95px",
    width: "95px",
    padding: "5px 10px 5px 5px",
  },
  imageContainer: { width: "125px", objectFit: "cover", marginRight: "5px" },
  resultImage: {
    height: "100px",
    objectFit: "cover",
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
    padding: "5px",
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
  },
};
